import React from 'react';

import AvGroup from './AvGroup';
import MoneySign from './MoneySign';
import MoneyInput from './MoneyInput';

export default props => (
  <AvGroup>
    <MoneySign />
    <MoneyInput {...props} />
  </AvGroup>
);
